class VerticalSlideshowComponent extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    const slidesContainer = this.querySelector('slideshow-slides');
    if (!slidesContainer) return;

    const slides = Array.from(slidesContainer.children).filter((element) => element.tagName === 'SLIDESHOW-SLIDE');
    if (slides.length < 2) return;

    const firstPhase = this.#createPhase(slides[1], slides[2]);
    slidesContainer.insertBefore(firstPhase, slides[1]);
    firstPhase.append(slides[1]);

    if (slides[2]) firstPhase.append(slides[2]);

    for (let index = 3; index < slides.length; index += 1) {
      const stickySlide = slides[index];
      const movingSlide = slides[index - 1].cloneNode(true);
      const phase = this.#createPhase(movingSlide, stickySlide, true);

      movingSlide.classList.remove('vertical-slideshow__sticky-slide');
      movingSlide.classList.add('vertical-slideshow__moving-slide--clone');
      movingSlide.setAttribute('aria-hidden', 'true');
      movingSlide.setAttribute('inert', '');
      movingSlide.removeAttribute('id');
      movingSlide.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));

      slidesContainer.insertBefore(phase, stickySlide);
      phase.append(movingSlide, stickySlide);
    }

    this.dataset.initialized = 'true';
  }

  #createPhase(movingSlide, stickySlide, overlapsPrevious = false) {
    const phase = document.createElement('div');

    phase.className = 'vertical-slideshow__phase';
    movingSlide.classList.add('vertical-slideshow__moving-slide');

    if (stickySlide) {
      stickySlide.classList.add('vertical-slideshow__sticky-slide');
    } else {
      phase.classList.add('vertical-slideshow__phase--single');
    }

    if (overlapsPrevious) phase.classList.add('vertical-slideshow__phase--overlap');

    return phase;
  }
}

if (!customElements.get('vertical-slideshow-component')) {
  customElements.define('vertical-slideshow-component', VerticalSlideshowComponent);
}
